module.exports = __webpack_public_path__ + "img/ep-oval.0123195d.jpg";